import * as universal from '../entries/pages/(admin)/admin/_layout.ts.js';
import * as server from '../entries/pages/(admin)/admin/_layout.server.ts.js';

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/_layout.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/(admin)/admin/+layout.ts";
export { server };
export const server_id = "src/routes/(admin)/admin/+layout.server.ts";
export const imports = ["_app/immutable/nodes/2.DM_3Sypv.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/DM11LlHJ.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/BQugib7O.js","_app/immutable/chunks/BTxgzX-9.js","_app/immutable/chunks/pTubWVUb.js","_app/immutable/chunks/BN8CHBz-.js","_app/immutable/chunks/B8SFHRoC.js","_app/immutable/chunks/BC3vKV3c.js","_app/immutable/chunks/CWir8Kn7.js"];
export const stylesheets = ["_app/immutable/assets/2.Cz_lkjv4.css"];
export const fonts = [];
